export const environment = {
  production: true,
  buildId: '2682599679118321',
  configFile: 'config.json',
};
